import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty, isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, ComponentLoader } from 'components';
import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import typeTasks from 'features/other/typeTasks';
import taskOverview from 'features/views/taskOverview';

import TaskTypeItem from './TaskTypeItem';

const { sortAndMergeTaskTypes } = taskOverview.utils;

export const TaskTypeList = ({ taskTypesCodelist }) => {
	const dispatch = useDispatch();
	const tasksFilterFormData = useFormData();
	const formIsInitiated = isObject(tasksFilterFormData);

	const taskTypeList = useSelector(taskOverview.selectors.getTasksList);
	const noFoundTasks = useSelector(taskOverview.selectors.getNoFoundTasks);
	const quickFilterState = useSelector(taskOverview.selectors.getQuickFilterState);
	const subheaderState = useSelector(taskOverview.selectors.getSubheaderState);

	useEffect(() => {
		dispatch(typeTasks.actions.setPersistTypeTasksVisibleState(false));

		if (formIsInitiated && (subheaderState || !isNilOrEmpty(tasksFilterFormData))) {
			dispatch(taskOverview.actions.submitTaskFilterForm());
		} else {
			dispatch(taskOverview.actions.fetchTaskTypeList(quickFilterState));
		}
		// eslint-disable-next-line
	}, []);

	const handleReload = useCallback(() => {
		dispatch(taskOverview.actions.reload());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.taskOverview} onReload={handleReload}>
			{(!isNilOrEmpty(taskTypeList) || noFoundTasks) && (
				<Stack>
					{sortAndMergeTaskTypes(taskTypeList, taskTypesCodelist).map((taskType) => (
						<TaskTypeItem key={taskType.taskTypeId} taskType={taskType} />
					))}
					{noFoundTasks && (
						<Alert sx={{ mt: 2 }} severity="info">
							{getLabelMessage('tasksOverview:noTaskFound')}
						</Alert>
					)}
				</Stack>
			)}
		</ComponentLoader>
	);
};

TaskTypeList.propTypes = {
	taskTypesCodelist: PropTypes.array,
};

export default codelistProvider(codelists.products, 'productsCodelist')(TaskTypeList);
